import { useLayer } from "./useLayer";
import { useContent } from "./useContent";
import { useMemo } from "react";

export function useLayerOutline() {
  const { outline: allOutline } = useContent();

  const layer = useLayer();

  const outline = useMemo(() => {
    switch (layer.type) {
      case "content":
        return allOutline.content;
      case "excursion":
        if (!layer.slug || !allOutline.excursions[layer.slug ?? ""]) return [];
        return allOutline.excursions[layer.slug] ?? [];
      default:
        return [];
    }
  }, [allOutline, layer]);

  return outline;
}
